export const LV_AccountTR={
AccoID:{en:'Account ID',cs:'ID účtu',dataType:'number',format:'#0',required:true},
AccoCode:{en:'Account Code',cs:'Číslo účtu',dataType:'string',required:true,maxLength:255},
AccoTimeStamp:{en:'AccoTimeStamp',cs:'AccoTimeStamp',dataType:'string'}
}